import { Component, Input } from "@angular/core";
import { GenericFieldDirective } from "../../directives/generic-field/generic-field.directive";
import { FormInput } from "../../interfaces/forms/form-element";

@Component({
    selector: "app-input-form",
    templateUrl: "./input-form.component.html",
    styleUrls: ["./input-form.component.scss"],
    standalone: false
})
export class InputFormComponent extends GenericFieldDirective {
  @Input() override field!: FormInput;

  textTransform(event: any, formControlName: string, method?: 'toUppercase' | 'toLowercase') {
    if(!method) return;

    if(method === 'toLowercase') this.formGroup.get(formControlName)?.setValue(event.target.value.toLowerCase());
    if(method === 'toUppercase') this.formGroup.get(formControlName)?.setValue(event.target.value.toUpperCase());
  }
}
